import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	InputAdornment,
	IconButton
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getUserManagementList } from "../../redux/actions/getUserManagementListAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { addNewWithdrawLimit } from "../../redux/actions/addNewWithdrawLimitAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import { countries } from "../../utils/countriesDropdown";
import { dealerAddUpdateDivisonList } from '../../redux/actions/dealerAddUpdateDivisionListAction';
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from '../../redux/actions/dealerAddUpdateThanaListAction';
import { dealerAddUpdateUnionList } from '../../redux/actions/dealerAddUpdateUnionListAction';
import { addEditUser } from "../../redux/actions/addEditUserAction";
import { blockUnblockUser } from "../../redux/actions/blockUnblockUserAction";
import { deleteUser } from "../../redux/actions/deleteUserAction";
import { getDeleteUserManagementList } from "../../redux/actions/getDeleteUserManagementListAction";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { FormGroup, Row, Col } from "reactstrap";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { getBlockUserManagement } from "../../redux/actions/getBlockUserManagementAction";
import { set } from "lodash";
import {
	getViewUserManagementList,
	resetViewUserList
} from "../../redux/actions/getViewUserManagementListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import { divisionListPartner } from "../../redux/actions/divisionListPartnerAction";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { districtListPartner } from "../../redux/actions/districtListPartnerAction";
import { thanaListPartner } from "../../redux/actions/thanaListPartnerAction";
import { unionListPartner } from "../../redux/actions/unionListPartnerAction";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const BackOffice = () => {
	const [name, setName] = useState("");
	const [username, setUserName] = useState("");
	const [getUserManagementStatus, setGetUserManagementStatus] = useState(false);
	const [getUserManagementResArray, setgetUserManagementResArray] = useState(
		[]
	);

	const [isLoading, setIsLoading] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [open, setOpen] = React.useState(false);
	const [addOpen, setAddOpen] = useState(false)
	const [viewOpen, setViewOpen] = useState(false)
	const [editOpen, setEditOpen] = useState(false)
	const [deleteNotification, setDeleteNotification] = useState(false)
	const [deleteopen, setDeleteOpen] = React.useState(false);
	const [deleteUserMaster, setDeleteUserMaster] = useState("")
	const [deleteUserStatus, setDeleteUserStatus] = useState(false)
	const [deleteUserArray, setDeleteUserArray] = useState("")
	const [blockopen, setBlockOpen] = React.useState(false);
	const [updatedUserManagementStatus, setUpdatedUserManagementStatus] =
		useState(false);

	const [hiddenPassword, setHiddenPassword] = useState("true");
	const [hiddenConPassword, setHiddenConPassword] = useState("true");
	const [buttonEnabled, setbuttonEnabled] = useState(false);

	const [userId, setUserId] = useState("")
	const [addEditOpen, setAddEditOpen] = useState(false)
	const [addEditUserStatus, setAddEditUserStatus] = useState(false)
	const [addEditUserArray, setAddEditUserArray] = useState("")
	const [blockUnblockUserStatus, setBlockUnblockUserStatus] = useState(false)
	const [blockUnblockUserArray, setBlockUnblockUserArray] = useState("")
	const [blockUnblockUserNoti, setBlockUnblockUserNoti] = useState(false)
	const getUserRes = useSelector(({ getUserList }) => getUserList);
	const [blockTooltip, setBlockTooltip] = useState("Block");
	const [unblockTooltip, setUnBlockTooltip] = useState("Unblock");
	const [divisionList, setdivisionList] = useState([]);
	const [districtList, setdistrictList] = useState([]);
	const [thanaList, setthanaList] = useState([]);
	const [unionList, setunionList] = useState([]);
	const [divisionBoolSet, setdivisionBoolSet] = useState(false);
	const [districtBoolSet, setdistrictBoolSet] = useState(false);
	const [thanaBoolSet, setthanaBoolSet] = useState(false);
	const [unionBoolSet, setunionBoolSet] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
	// const [twoFactorAuthen, setTwoFactorAuthen] = useState("N");
	

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const getPartnerLogin = useSelector(({ login }) => login);
	const [deleteAcc, setDeleteAcc] = useState("");
	const [blockAcc, setBlockAcc] = useState("");
	var authToken = regenerateTokenRes.data.AuthToken;

	const [requestInput, setRequestInput] = useState({
		userName: "",
		password: "",
		cnfmPassword: "",
		role: "",
		fullName: "",
		email: "",
		phoneNo: "",
		address: "",
		country: "",
		state: "",
		city: "",
		postalCode: "",

		division: "",
		district: "",
		thana: "",
		union: "",
		twoFactorGoogle :"N"

	})

	const {
		userName,
		password,
		cnfmPassword,
		role,
		fullName,
		email,
		phoneNo,
		address,
		country,
		state,
		city,
		postalCode,

		division,
		district,
		thana,
		union,
		twoFactorGoogle
	} = requestInput

	const onInputChangeMod = ({ target: { name, value } }, type) => {
		const obj = {
			...requestInput,
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setRequestInput(obj);
		const requiredFields = ["userName", "password", "cnfmPassword", "role", "fullName", "address", "country"];
		const allFieldsFilled = requiredFields.every((field) => obj[field] !== '');
		setbuttonEnabled(allFieldsFilled)
	};

	const dispatch = useDispatch();
	const classes = useStyles();
	const handleChange = ({ target: { name, value } }) => {
		if (name === "name") {
			setName(value);
		}
		if (name === "username") {
			setUserName(value);
		}
		// if (name === "twoFactorAuthen") {
		// 	setTwoFactorAuthen(value);
		// }
	};

	const setDivisionList = useSelector(
		({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
	)

	const setDistrictList = useSelector(
		({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
	)

	const setThanaList = useSelector(
		({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
	)

	const setUnionList = useSelector(
		({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
	)

	const addEditUserRes = useSelector(
		({ addEditUser }) => addEditUser
	);

	const blockUnblockUserRes = useSelector(
		({ blockUnblockUser }) => blockUnblockUser
	);

	const deleteUserRes = useSelector(
		({ deleteUser }) => deleteUser
	);

	const getUserManagementRes = useSelector(
		({ getUserManagementlist }) => getUserManagementlist
	);

	const divisionListPartnerRes = useSelector(({ divisionListPartner }) => divisionListPartner);
	const districtListPartnerRes = useSelector(({ districtListPartner }) => districtListPartner);
	const thanaListPartnerRes = useSelector(({ thanaListPartner }) => thanaListPartner);
	const unionListPartnerRes = useSelector(({ unionListPartner }) => unionListPartner);

	const setDivisionListFunc = () => {
		if (divisionBoolSet) {
			if (divisionListPartnerRes.data.status === 'Success') {
				setdivisionList(divisionListPartnerRes.data.list);
			}
			if (divisionListPartnerRes.data.status === 'Failed') {
				setAddOpen(false);
				NotificationPopups("error", "Failed", divisionListPartnerRes.data.description)
				if (
					divisionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					divisionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	const setDistrictListFunc = () => {
		if (districtBoolSet) {
			if (districtListPartnerRes.data.status === 'Success') {
				setdistrictList(districtListPartnerRes.data.list);
			}
			if (districtListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", districtListPartnerRes.data.description)
				if (
					districtListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					districtListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	const thanaListFunc = () => {
		if (thanaBoolSet) {
			if (thanaListPartnerRes.data.status === 'Success') {
				setthanaList(thanaListPartnerRes.data.list);
			}
			if (thanaListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", thanaListPartnerRes.data.description)
				if (
					thanaListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					thanaListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	const unionListFunc = () => {
		if (unionBoolSet) {
			if (unionListPartnerRes.data.status === 'Success') {
				setunionList(unionListPartnerRes.data.list)
			}
			if (unionListPartnerRes.data.status === 'Failed') {
				NotificationPopups("error", "Failed", unionListPartnerRes.data.description)
				if (
					unionListPartnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					unionListPartnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		setDivisionListFunc();
	}, [divisionListPartnerRes.data.status]);

	useEffect(() => {
		setDistrictListFunc();
	}, [districtListPartnerRes.data.status]);

	useEffect(() => {
		thanaListFunc();
	}, [thanaListPartnerRes.data.status]);

	useEffect(() => {
		unionListFunc();
	}, [unionListPartnerRes.data.status]);

	const setAddUpdateDivisionListReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
			}
		}
		dispatch(dealerAddUpdateDivisonList(req, authToken))
	}

	const setAddUpdateDistrictListReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				district: requestInput.division
			}
		}
		dispatch(dealerAddUpdateDistrictList(req, authToken))
	}

	useEffect(() => {
		if (division) {
			setAddUpdateDistrictListReq()
		}
	}, [division])

	const setAddUpdateThanaListReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				district: division
			}
		}
		dispatch(dealerAddUpdateThanaList(req, authToken))
	}

	useEffect(() => {
		if (division) {
			setAddUpdateThanaListReq()
		}
	}, [division])

	const setAddUpdateUnionListReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				district: division,
				thana: thana

			}
		}
		dispatch(dealerAddUpdateUnionList(req, authToken))
	}


	useEffect(() => {
		if (division && thana) {
			setAddUpdateUnionListReq()
		}
	}, [division, thana])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setAddUpdateDivisionListReq()
			getUserManagement()
		}
	}, [regenerateTokenRes.data.status])

	const addEditUserReq = () => {
		setAddEditUserStatus(true)
		let req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId,
				ratId: userId,
				userName: userName,
				password: password,
				subRole: role,
				fullName: fullName,
				email: email,
				mobileNumber: phoneNo,
				address: address,
				country: country,
				division: requestInput.division,
				district: requestInput.district,
				thana: requestInput.thana,
				union: requestInput.union,
				postalCode: postalCode,
				regionId: 1,
				areaId: 1,
				role: getPartnerLogin.data.Role,
				state: requestInput.state,
				city: requestInput.city,
				twoFactorGoogle: requestInput.twoFactorGoogle
			}
		}
		dispatch(addEditUser(req, authToken));
		handleClose();
	}

	const addEditUserFunc = () => {
		if (addEditUserStatus) {
			if (addEditUserRes.data.status == "success") {
				setAddEditUserArray(addEditUserRes.data)
				setAddEditOpen(true)
				getUserManagement()
			}
			if (addEditUserRes.data.status == "failed") {
				setAddEditUserArray(addEditUserRes.data)
				setAddEditOpen(true);
				if (
					addEditUserRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addEditUserRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		addEditUserFunc()
	}, [addEditUserRes.data.status])

	const getUserManagement = () => {
		setGetUserManagementStatus(true);
		setIsLoading(true);
		const getUserManagementReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				userName: username,
				ratName: name,
				// twoFactorGoogle :twoFactorAuthen

			}
		};

		return dispatch(getUserManagementList(getUserManagementReq, authToken));
	};

	const getviewUserManagementRes = useSelector(
		({ getViewUserManagementlist }) => getViewUserManagementlist
	);

	const getBlockUserManagementRes = useSelector(
		({ getblockUserManagement }) => getblockUserManagement
	);
	const ViewUserManagementList = (custid, type) => {
		const getUserManagementReq = {
			loginDetails: {
				waletOwnerId: regenerateTokenRes.data.partnerId
			},
			actionCustomerMasterRequestVO: {
				ratId: custid,
				// twoFactorGoogle :twoFactorAuthen
			}
		};
		dispatch(getViewUserManagementList(getUserManagementReq, authToken));
		if (type == "view") {
			setViewOpen(true)
		}
		if (type == "edit") {
			setEditOpen(true)
			setUserId(custid)
		}
	};

	const getUserManagementStatusFunc = () => {
		if (getUserManagementStatus) {
			if (getUserManagementRes.data.status == "success") {
				setIsLoading(false);
				if (getUserManagementRes.data.errorList) {
					setgetUserManagementResArray(
						[].concat(getUserManagementRes.data.errorList)
					);
				} else {
					setgetUserManagementResArray([]);
				}
			}
			if (getUserManagementRes.data.status == "failed") {
				setIsLoading(false);
				setgetUserManagementResArray(getUserManagementRes.data);
				if (
					getUserManagementRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUserManagementRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getUserManagementRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetUserManagementResArray(getUserManagementRes.data);
			}
		}
	};


	const blockUnblockUserReq = (type, id) => {
		setBlockUnblockUserStatus(true)
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId,
			},
			actionCustomerMasterRequestVO: {
				action: type,
				ratId: id,
				isAccountLocked: type == "block" ? 0 : 1,
			}
		}

		dispatch(blockUnblockUser(req, authToken))
	}

	const blockUnblockUserFunc = () => {
		if (blockUnblockUserStatus) {
			if (blockUnblockUserRes.data.status == "success") {
				setBlockUnblockUserArray(blockUnblockUserRes.data)
				setBlockUnblockUserNoti(true)
				getUserManagement()
			}
			if (blockUnblockUserRes.data.status == "failed") {
				setBlockUnblockUserArray(blockUnblockUserRes.data)
				setBlockUnblockUserNoti(true);
				if (
					blockUnblockUserRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					blockUnblockUserRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		blockUnblockUserFunc()
	}, [blockUnblockUserRes.data.status])


	const deleteUserReq = () => {
		setDeleteUserStatus(true)
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId
			},
			actionCustomerMasterRequestVO: {
				ratId: deleteUserMaster
			}
		}
		dispatch(deleteUser(req, authToken))
		setDeleteOpen(false);
	}

	const deleteUserFunct = () => {
		if (deleteUserStatus) {
			if (deleteUserRes.data.status == "success") {
				setDeleteUserArray(deleteUserRes.data)
				setDeleteNotification(true)
				getUserManagement()
			}
			if (deleteUserRes.data.status == "failed") {
				setDeleteUserArray(deleteUserRes.data)
				setDeleteNotification(true)
				if (
					deleteUserRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteUserRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}

	useEffect(() => {
		deleteUserFunct()
	}, [deleteUserRes.data.status])

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	// const SetViewUserManagementList = (custId) => {
	//     ViewUserManagementList(custId);
	// };

	const handleClose = () => {
		setViewOpen(false);
		setEditOpen(false)
		setDeleteOpen(false);
		setBlockOpen(false);
		setAddOpen(false)
		setbuttonEnabled(false);
		setRequestInput({
			userName: "",
			password: "",
			cnfmPassword: "",
			role: "",
			fullName: "",
			email: "",
			phoneNo: "",
			address: "",
			country: "",
			state: "",
			city: "",
			postalCode: "",

			division: "",
			district: "",
			thana: "",
			union: "",
			twoFactorGoogle:""
		})
		setdivisionList([]);
		setdistrictList([]);
		setthanaList([]);
		setunionList([]);
	};

	const deleteIntegrationRes = useSelector(
		({ getDeleteUserManagementlist }) => getDeleteUserManagementlist
	);

	const deleteIntegrationFunc = (value) => {
		setDeleteAcc(value);
		setDeleteOpen(true);
	};

	const deleteUserFunc = (value) => {
		setDeleteUserMaster(value);
		// setEditOpen(false);
		// setViewOpen(false)
		// setAddOpen(false)
		setDeleteOpen(true);
	};

	const blockIntegration = (custId) => {
		setBlockAcc(custId);
		setBlockOpen(true);
	};

	const handleNoticationClose = () => {
		setAddEditOpen(false)
		setBlockUnblockUserNoti(false)
		setDeleteNotification(false)
	};

	const togglePassword = (e) => {
		e.preventDefault();
		setHiddenPassword((state) => !state);
	};

	const toggleConPassword = (e) => {
		e.preventDefault();
		setHiddenConPassword((state) => !state);
	};

	useEffect(() => {
		if (getUserManagementStatus) {
			getUserManagementStatusFunc();
		}
	}, [getUserManagementRes.data.status]);

	useEffect(() => {
		if (getUserManagementRes.data.status == "success") {
			setPage(0);
		}
	}, [getUserManagementRes.data.status]);

	// useEffect(() => {
	// 	if (getviewUserManagementRes.data.status == "Success") {
	// 		setuserName(getviewUserManagementRes.data.viewMgtList.userName);
	// 		setrole(getviewUserManagementRes.data.viewMgtList.role);
	// 		setfullName(getviewUserManagementRes.data.viewMgtList.fullName);
	// 		setemail(getviewUserManagementRes.data.viewMgtList.email);
	// 		setphone(getviewUserManagementRes.data.viewMgtList.phoneNo);
	// 		setarea(getviewUserManagementRes.data.viewMgtList.city);
	// 		setaddress(getviewUserManagementRes.data.viewMgtList.address);
	// 		setcountry(getviewUserManagementRes.data.viewMgtList.country);
	// 	}
	// }, [getviewUserManagementRes.data.status]);

	useEffect(() => {
		if (getviewUserManagementRes.data.status == "Success") {
			setRequestInput({
				userName: getviewUserManagementRes.data.viewMgtList.userName,
				// password: getviewUserManagementRes.data.,
				// cnfmPassword: getviewUserManagementRes.data.,
				role: getviewUserManagementRes.data.viewMgtList.role,
				fullName: getviewUserManagementRes.data.viewMgtList.fullName,
				email: getviewUserManagementRes.data.viewMgtList.email,
				phoneNo: getviewUserManagementRes.data.viewMgtList.phoneNo,
				address: getviewUserManagementRes.data.viewMgtList.address,
				country: getviewUserManagementRes.data.viewMgtList.country,
				state: getviewUserManagementRes.data.viewMgtList.state,
				city: getviewUserManagementRes.data.viewMgtList.city,
				postalCode: getviewUserManagementRes.data.viewMgtList.postalCode,
				twoFactorGoogle:getviewUserManagementRes.data.viewMgtList.twoFactorGoogle
			})
			
		}
	}, [getviewUserManagementRes.data.status])

	useEffect(() => {
		return () => {
			dispatch(resetViewUserList());
		};
	}, []);

	const openAdd = () => {
		setAddOpen(true)
	}

	useEffect(() => {
		disabledFunc();
	}, [userName, password, cnfmPassword, role, fullName, address, country])

	const disabledFunc = () => {
		if (userName && password && cnfmPassword && role && fullName && address && country && (password === cnfmPassword)) {
			return false;
		} else {
			return true;
		}
	}

	useEffect(() => {
		if (country === 'Bangladesh') {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId
				}
			}
			dispatch(divisionListPartner(req, authToken))
			setdivisionBoolSet(true);
		}
	}, [country]);

	useEffect(() => {
		if (division) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: division
				}
			}
			dispatch(districtListPartner(req, authToken));
			setdistrictBoolSet(true);
		}
	}, [division]);


	useEffect(() => {
		if (district) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district
				}
			}
			dispatch(thanaListPartner(req, authToken));
			setthanaBoolSet(true);
		}
	}, [district]);

	useEffect(() => {
		if (thana) {
			const req = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId,
					district: district,
					thana: thana
				}
			}
			dispatch(unionListPartner(req, authToken));
			setunionBoolSet(true);
		}
	}, [thana]);

	useEffect(() => {
		if (userName) {
		  setIsSaveDisabled(false);
		} else {
		  setIsSaveDisabled(true);
		}
	  }, [userName]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						<Grid item md={3} sm={12} xs={12} lg={2}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => openAdd()}
							>
								Add New User
							</CustomButton>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Name"
								type="text"
								fullWidth
								variant="standard"
								value={name}
								name="name"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="User Name"
								fullWidth
								variant="standard"
								type="text"
								name="username"
								value={username || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
                                style={{
                                    marginLeft: "0.7rem",
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "9px",
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                                onClick={getUserManagement}
                            >
                                Search
                            </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getUserManagement}
							// endIcon={<SaveIcon />}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{/* console.log({getUserManagementResArray.status}) */}
				{isLoading ? (
					<LoadingSpinner />
				) : getUserManagementResArray.length == undefined ||
					getUserManagementResArray.length == 0 ||
					!getUserManagementStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									User Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									User Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Sr.No</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												User ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												User Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Role
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getUserManagementResArray &&
											[]
												.concat(getUserManagementResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={index}>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">
															{row.customerId}
														</TableCell>
														<TableCell align="center">{row.name}</TableCell>
														<TableCell align="center">{row.userName}</TableCell>
														<TableCell align="center">{row.mobile}</TableCell>
														<TableCell align="center">{row.subRole}</TableCell>

														<TableCell align="center">
															<Tooltip title="View">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		ViewUserManagementList(row.customerId, "view")
																	}
																>
																	{/* View */}
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>

															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		ViewUserManagementList(row.customerId, "edit")
																	}
																>

																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
															<Tooltip title="Delete">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		deleteUserFunc(row.customerId)
																	}
																>
																	{
																		<DeleteIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
															<Tooltip title={blockTooltip}>
																{row.isAccLocked == 0 ?
																	(<CustomButton
																		style={{
																			padding: "10px"
																		}}
																		onClick={() =>
																			blockUnblockUserReq("block", row.customerId)
																		}
																	>
																		Block
																	</CustomButton>)

																	: (
																		<Tooltip title={unblockTooltip}>
																	<CustomButton
																		style={{
																			padding: "10px"
																		}}
																		onClick={() =>
																			blockUnblockUserReq("unblock", row.customerId)
																		}
																	>
																		Unblock
																	</CustomButton>
																	</Tooltip>
																	)}
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getUserManagementResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle>Add New User</DialogTitle>
						<DialogContent>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Username"
									fullWidth={true}
									name="userName"
									variant="standard"
									value={userName || ""}
									
									onChange={(e) => onInputChangeMod(e, "both")}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Passwords length should be at least 8 and should contain alphabet, numeric, and special characters like !@#$)"
											type={hiddenPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Password"
											fullWidth={true}
											name="password"
											id="password"
											value={password}
											onChange={(e) => onInputChangeMod(e)}
										
									variant="standard"

											error={
												(password && password.length < 8) ? (
													<p className="passwordNotMatch" style={{ color: "red" }}>
														{password.length > 0
															? "Password should be at least 8 characters"
															: ""}
													</p>
												) : (
													""
												)
											}

											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={togglePassword}
															onMouseDown={togglePassword}
														>
															{hiddenPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<FormGroup>
									<FormControl fullWidth>
										<TextField
											required
											helperText="(Should be same as Password)"
											type={hiddenConPassword ? "password" : "text"}
											size="small"
											color="primary"
											autoFocus={true}
											label="Confirm Password"
											fullWidth={true}
											variant="standard"
											name="cnfmPassword"
											id="cnfmPassword"
											value={cnfmPassword}
											onChange={(e) => onInputChangeMod(e)}
										
											error={
												password &&
													password !== cnfmPassword &&
													cnfmPassword ? (
													<p
														className="passwordNotMatch"
														style={{ color: "red" }}
													>
														{"Password did not match"}
													</p>
												) : (
													""
												)
											}
											InputProps={{
												endAdornment: (
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={toggleConPassword}
															onMouseDown={toggleConPassword}
														>
															{hiddenConPassword ? (
																<VisibilityOff />
															) : (
																<Visibility />
															)}
														</IconButton>
													</InputAdornment>
												),
											}}
										/>
									</FormControl>
								</FormGroup>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Role"
									fullWidth={true}
									variant="standard"

									name="role"
									defaultValue={role || "Select Role"}
									onChange={(e) => onInputChangeMod(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Role" selected="Select Role">
										Select Role
									</MenuItem>
									<MenuItem value="SubOwner">SubOwner</MenuItem>
									<MenuItem value="Cashier">Cashier</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Full Name"
									fullWidth={true}
									name="fullName"
									variant="standard"

									value={fullName || ""}
									onChange={(e) => onInputChangeMod(e, "alphabet")}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Email"
									fullWidth={true}
									variant="standard"

									name="email"
									value={email || ""}
									onChange={(e) => onInputChangeMod(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Phone Number"
									fullWidth={true}
									variant="standard"

									name="phoneNo"
									value={phoneNo || ""}
									onChange={(e) => onInputChangeMod(e, "number")}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								></TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Address"
									fullWidth={true}
									name="address"
									variant="standard"

									value={address || ""}
									onChange={(e) => onInputChangeMod(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>
							<TextField
									select
									margin="dense"
									id="name"
									label="Two Factor Google Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									// defaultValue={twoFactorAuthen || ""}
									// onChange={handleChange}
								value={twoFactorGoogle  || ""}

								onChange={(e) => onInputChangeMod(e, "alphabet")}

									name="twoFactorGoogle"
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
							{/* <TextField
									select
									margin="dense"
									id="name"
									label="Two Factor Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={twoFactorAuthen || ""}
									onChange={handleChange}
									name="twoFactorAuthen"
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField> */}

							<div style={{ marginTop: "1.5rem" }}>
								{" "}
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="string"
									label="Country"
									fullWidth={true}
									name="country"
									variant="standard"

									// value={country}
									defaultValue={"Select Country" || country}
									onChange={(e) => onInputChangeMod(e)}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Country" selected="Select Country">
										Select Country
									</MenuItem>

									{countries.map((x) => (
										<MenuItem value={x.label}>
											{x.label}
										</MenuItem>
									))}
								</TextField>
							</div>

							{country == "Bangladesh" &&
								(<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Division"
											fullWidth={true}
											name="division"
									variant="standard"

											defaultValue={division || "Select Divison"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Divison" selected="Select Divison">
												Select Division
											</MenuItem>
											{divisionList &&
												[].concat(divisionList).map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="District"
											fullWidth={true}
									variant="standard"

											name="district"
											defaultValue={district || "Select District"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select District" selected="Select District">
												Select District
											</MenuItem>
											{districtList &&
												[].concat(districtList).map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Thana/Upazilla"
											fullWidth={true}
									variant="standard"

											name="thana"
											defaultValue={thana || "Select Thana/Upazilla"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
												Select Thana/Upazilla
											</MenuItem>

											{thanaList &&
												[].concat(thanaList).map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Union/Ward"
											fullWidth={true}
									variant="standard"

											name="union"
											defaultValue={union || "Select Union/Ward"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Union/Ward" selected="Select Union/Ward">
												Select Union/Ward
											</MenuItem>
											{unionList &&
												[].concat(unionList).map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div></>)}

							{country && country !== "Bangladesh" && (
								<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="State"
											fullWidth={true}
											name="state"
									variant="standard"

											value={state || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="City"
											fullWidth={true}
											name="city"
									variant="standard"

											value={city || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Postal Code"
											fullWidth={true}
									variant="standard"

											name="postalCode"
											value={postalCode || ""}
											onChange={(e) => onInputChangeMod(e, "number")}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>
								</>
							)}

						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={addEditUserReq}
								disabled={!buttonEnabled}
							>
								Add
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View User</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Username"
								variant="standard"

								fullWidth={true}
								name="userName"
								value={userName || ""}
								onChange={(e) => onInputChangeMod(e, "alphabet")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								required
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								variant="standard"

								name="role"
								defaultValue={role || "Select Role"}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								<MenuItem value="SubOwner">SubOwner</MenuItem>
								<MenuItem value="Cashier">Cashier</MenuItem>
							</TextField>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Full Name"
								fullWidth={true}
								name="fullName"
								variant="standard"

								value={fullName || ""}
								onChange={(e) => onInputChangeMod(e, "alphabet")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Email"
								fullWidth={true}
								name="email"
								variant="standard"

								value={email || ""}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Phone Number"
								fullWidth={true}
								name="phoneNo"
								variant="standard"

								value={phoneNo || ""}
								onChange={(e) => onInputChangeMod(e, "number")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Address"
								fullWidth={true}
								name="address"
								variant="standard"

								value={address || ""}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
									select
								disabled

									margin="dense"
									id="name"
									label="Two Factor Google Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									// defaultValue={twoFactorAuthen || ""}
									// onChange={handleChange}
								value={twoFactorGoogle  || ""}

								onChange={(e) => onInputChangeMod(e, "alphabet")}

									name="twoFactorGoogle"
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
							{/* <TextField
									select
									margin="dense"
									id="name"
								disabled

									label="Two Factor Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={twoFactorAuthen || ""}
									onChange={handleChange}
									name="twoFactorAuthen"
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>	 */}

							{" "}
							<TextField
								style={{ marginTop: "1.5rem" }}
								disabled
								required
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="string"
								label="Country"
								fullWidth={true}
								name="country"
								variant="standard"

								// value={country}
								value={country || "Select Country"}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Country" selected="Select Country">
									Select Country
								</MenuItem>

								{countries.map((x) => (
									<MenuItem value={x.label}>
										{x.label}
									</MenuItem>
								))}
							</TextField>
							{country == "Bangladesh" &&
								(<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											// select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Division"
											fullWidth={true}
											name="division"
									variant="standard"

											defaultValue={division || "Select Divison"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Divison" selected="Select Divison">
												Select Division
											</MenuItem>
											{setDivisionList.success &&
												setDivisionList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											// select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="District"
											fullWidth={true}
									variant="standard"

											name="district"
											defaultValue={district || "Select District"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select District" selected="Select District">
												Select District
											</MenuItem>
											{setDistrictList.success &&
												setDistrictList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											// select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Thana/Upazilla"
											fullWidth={true}
											name="thana"
									variant="standard"

											defaultValue={thana || "Select Thana/Upazilla"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
												Select Thana/Upazilla
											</MenuItem>

											{setThanaList.success &&
												setThanaList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											// select
											type="text"
											size="small"
											color="primary"
									variant="standard"

											autoFocus={true}
											label="Union/Ward"
											fullWidth={true}
											name="union"
									

											defaultValue={union || "Select Union/Ward"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Union/Ward" selected="Select Union/Ward">
												Select Union/Ward
											</MenuItem>
											{setUnionList.success &&
												setUnionList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div></>)}

							{country !== "Bangladesh" && (
								<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="State"
											fullWidth={true}
											name="state"
									variant="standard"

											value={state || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="City"
									variant="standard"

											fullWidth={true}
											name="city"
											value={city || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											disabled
											type="text"
											size="small"
											color="primary"
									variant="standard"

											autoFocus={true}
											label="Postal Code"
											fullWidth={true}
											name="postalCode"
											value={postalCode || ""}
											onChange={(e) => onInputChangeMod(e, "number")}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>
								</>
							)}
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit User</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "1.5rem" }}
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Username"
								fullWidth={true}
								variant="standard"

								name="userName"
								value={userName || ""}
								onChange={(e) => onInputChangeMod(e, "alphabet")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								required
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Role"
								fullWidth={true}
								name="role"
								variant="standard"
								
								defaultValue={role}
								disabled

								// defaultValue={role || "Select Role"}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								<MenuItem value="SubOwner">SubOwner</MenuItem>
								<MenuItem value="Cashier">Cashier</MenuItem>
							</TextField>
							<TextField
								style={{ marginTop: "1.5rem" }}
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Full Name"
								fullWidth={true}
								name="fullName"
								variant="standard"

								value={fullName || ""}
								onChange={(e) => onInputChangeMod(e, "alphabet")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Email"
								fullWidth={true}
								name="email"
								variant="standard"

								value={email || ""}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
							<TextField
								style={{ marginTop: "1.5rem" }}
								type="text"
								size="small"
								color="primary"
								variant="standard"

								autoFocus={true}
								label="Phone Number"
								fullWidth={true}
								name="phoneNo"
								value={phoneNo || ""}
								onChange={(e) => onInputChangeMod(e, "number")}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								style={{ marginTop: "1.5rem" }}
								required
								type="text"
								size="small"
								color="primary"
								autoFocus={true}
								label="Address"
								variant="standard"

								fullWidth={true}
								name="address"
								value={address || ""}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
								<TextField
									select
									margin="dense"
									id="name"
									label="Two Factor Google Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									// defaultValue={twoFactorAuthen || ""}
									// onChange={handleChange}
								value={twoFactorGoogle  || ""}

								onChange={(e) => onInputChangeMod(e, "alphabet")}

									name="twoFactorGoogle"
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
							{" "}
							<TextField
								style={{ marginTop: "1.5rem" }}
								required
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="string"
								label="Country"
								variant="standard"

								fullWidth={true}
								name="country"
								// value={country}
								value={country || "Select Country"}
								onChange={(e) => onInputChangeMod(e)}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Country" selected="Select Country">
									Select Country
								</MenuItem>

								{countries.map((x) => (
									<MenuItem value={x.label}>
										{x.label}
									</MenuItem>
								))}
							</TextField>
							{country == "Bangladesh" &&
								(<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Division"
								variant="standard"

											fullWidth={true}
											name="division"
											defaultValue={division || "Select Divison"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Divison" selected="Select Divison">
												Select Division
											</MenuItem>
											{/* {setDivisionList.success} */}
											{setDivisionList.success &&
												setDivisionList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
								variant="standard"

											label="District"
											fullWidth={true}
											name="district"
											defaultValue={district || "Select District"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select District" selected="Select District">
												Select District
											</MenuItem>
											{setDistrictList.success &&
												setDistrictList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Thana/Upazilla"
								variant="standard"

											fullWidth={true}
											name="thana"
											defaultValue={thana || "Select Thana/Upazilla"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
												Select Thana/Upazilla
											</MenuItem>

											{setThanaList.success &&
												setThanaList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											select
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Union/Ward"
								variant="standard"

											fullWidth={true}
											name="union"
											defaultValue={union || "Select Union/Ward"}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										>
											<MenuItem value="Select Union/Ward" selected="Select Union/Ward">
												Select Union/Ward
											</MenuItem>
											{setUnionList.success &&
												setUnionList.data.list.map((x) => (
													<MenuItem value={x.name}>{x.name}</MenuItem>
												))}
										</TextField>
									</div></>)}

							{country !== "Bangladesh" && (
								<>
									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="State"
											fullWidth={true}
								variant="standard"

											name="state"
											value={state || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
								variant="standard"

											autoFocus={true}
											label="City"
											fullWidth={true}
											name="city"
											value={city || ""}
											onChange={(e) => onInputChangeMod(e)}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>

									<div style={{ marginTop: "1.5rem" }}>
										<TextField
											type="text"
											size="small"
											color="primary"
											autoFocus={true}
											label="Postal Code"
											fullWidth={true}
								variant="standard"

											name="postalCode"
											value={postalCode || ""}
											onChange={(e) => onInputChangeMod(e, "number")}
											InputProps={{
												sx: {
												  "&:before": { borderBottomColor: "gray" }, // before focus
												  "&:after": { borderBottomColor: "gray" },  // after focus
												},
											  }}
											  InputLabelProps={{
												sx: { color: 'gray' }, // Optional: if you want the label to be white
											  }}
										/>
									</div>
								</>
							)}
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={addEditUserReq}
								disabled={isSaveDisabled}

							>
								Edit
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={deleteopen} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={deleteUserReq}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={blockopen} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
							// onClick={getBlockUserManagementList}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				{/* <div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>User Management</DialogTitle>
						<DialogContent>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="User Name*"
								type="name"
								fullWidth
								variant="standard"
								value={userName || ""}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Role*"
								type="name"
								fullWidth
								variant="standard"
								value={role || ""}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Full Name*"
								type="name"
								fullWidth
								variant="standard"
								value={fullName || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Email"
								type="name"
								fullWidth
								variant="standard"
								value={email || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Phone Number"
								type="name"
								fullWidth
								variant="standard"
								value={phone || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Region*"
								type="name"
								fullWidth
								variant="standard"
								value={region || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Region/Area/Teritory Name*"
								type="name"
								fullWidth
								variant="standard"
								value={area || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Address*"
								type="name"
								fullWidth
								variant="standard"
								value={address || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Country*"
								type="name"
								fullWidth
								variant="standard"
								value={country || ""}
								disabled
							/>

							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Division*"
								type="name"
								fullWidth
								variant="standard"
								value={division || ""}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="District*"
								type="name"
								fullWidth
								variant="standard"
								value={district || ""}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Thana/Upzilla*"
								type="name"
								fullWidth
								variant="standard"
								value={thana || ""}
								disabled
							/>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Union/Ward*"
								type="name"
								fullWidth
								variant="standard"
								value={district || ""}
								disabled
							/>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div> */}
			</Layout>
			{/* {getBlockUserManagementRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getBlockUserManagementRes.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getBlockUserManagementRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {getBlockUserManagementRes.data.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )} */}

			{blockUnblockUserRes.data.status == "success" && (
				<div>
					<Dialog open={blockUnblockUserNoti} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{blockUnblockUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{blockUnblockUserRes.data.status == "failed" && (
				<div>
					<Dialog open={blockUnblockUserNoti} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{blockUnblockUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addEditUserRes.data.status == "success" && (
				<div>
					<Dialog open={addEditOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addEditUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addEditUserRes.data.status == "failed" && (
				<div>
					<Dialog open={addEditOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addEditUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteUserRes.data.status == "success" && (
				<div>
					<Dialog open={deleteNotification} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteUserRes.data.status == "failed" && (
				<div>
					<Dialog open={deleteNotification} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteUserArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px",
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default BackOffice;
